import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { HYDRATE } from 'next-redux-wrapper'

import { RootState } from '~/redux/store'

import {
  Employee,
  EmployeeCategory,
  EmployeeFields,
  EmployeeFieldsError,
  EmployeeState,
} from '~/employee/types/employee.types'

const INIT_EMPLOYEE_FIELDS = {
  employees: [],
  categories: [],
}
const INIT_EMPLOYEE_FIELDS_ERRORS = {
  employees: '',
  categories: '',
}
const initialState: EmployeeState = {
  fields: INIT_EMPLOYEE_FIELDS,
  errors: INIT_EMPLOYEE_FIELDS_ERRORS,
  backendError: '',
}

const slice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    setEmployeeFieldsErrors: (state, action: PayloadAction<EmployeeFieldsError>) => ({
      ...state,
      errors: action.payload,
    }),

    setEmployeeFields: (state, action: PayloadAction<EmployeeFields>) => ({
      ...state,
      fields: action.payload,
    }),

    setEmployeeBackendError: (state, action: PayloadAction<string>) => ({
      ...state,
      backendError: action.payload,
    }),
  },

  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      return {
        ...state,
        ...action.payload.employee,
      }
    })
  },
})

export const selectEmployeeFieldsErrors = (state: RootState): EmployeeFieldsError => state.employee.errors

export const selectEmployeeFields = (state: RootState): EmployeeFields => state.employee.fields

export const selectEmployeeBackendError = (state: RootState): string => state.employee.backendError

export const selectEmployee = (state: RootState): Employee[] => state.employee.fields.employees

export const selectCategories = (state: RootState): EmployeeCategory[] => state.employee.fields.categories

export const {
  setEmployeeFieldsErrors: setEmployeeFieldsErrorsActionCreator,
  setEmployeeFields: setEmployeeFieldsActionCreator,
  setEmployeeBackendError: setEmployeeBackendErrorActionCreator,
} = slice.actions

export default slice.reducer
